"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessageContainer = exports.Text = exports.Checkbox = exports.Label = exports.Container = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const setSizing = (props) => {
    var _a, _b, _c, _d;
    const defaultHeight = 'auto';
    const defaultWidth = '100%';
    const height = (_b = (_a = props.size) === null || _a === void 0 ? void 0 : _a.height) !== null && _b !== void 0 ? _b : defaultHeight;
    const width = (_d = (_c = props.size) === null || _c === void 0 ? void 0 : _c.width) !== null && _d !== void 0 ? _d : defaultWidth;
    return (0, styled_components_1.css) `
    height: ${height};
    width: ${width};
  `;
};
exports.Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  ${setSizing}
`;
exports.Label = styled_components_1.default.label `
  width: 100%;
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  font-weight: normal;
  padding: 8px;
  position: relative;
  background: #ebf5ff;
  border-radius: 8px;
  border: 1px solid ${({ error }) => (error ? monera_app_core_1.Red_500 : monera_app_core_1.Gray_1200)};
`;
exports.Checkbox = styled_components_1.default.input.attrs({ type: 'checkbox' }) `
  margin-right: 10px;
  cursor: pointer;
  scale: 1.5;

  &:checked {
    accent-color: ${monera_app_core_1.Blue_400};
    font-weight: bold;
  }
`;
exports.Text = styled_components_1.default.span `
  font-size: 14px;
  color: #000;
`;
exports.ErrorMessageContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: 10px;
`;
